import { memo } from 'react'
import { Activity } from '../../../pure-js/types/GrooverTypes'
import { FOUR_PX, SIXTEEN_PX } from '../enums/Spacings'
import { getWeekdayAbbreviation } from '../libs/DayJsHelper'
import Box from './Box'

type Props = {
  activity: Activity
}

const ClosedActivityDetails = ({ activity }: Props) => (
  <Box direction="row" gap={SIXTEEN_PX}>
    <span>{activity.startDate}</span>
    <Box direction="row" gap={FOUR_PX}>
      <span>{getWeekdayAbbreviation(activity.startDate)}</span>
      <span>{activity.time}</span>
    </Box>
  </Box>
)

export default memo(ClosedActivityDetails)
